import "./Home.css";
import Card from '../../components/card/Card';

export default function Home() {
    const scrollToTop = () => {
	    window.scrollTo(0, 0)
	};

    return (
        <div className="row">
            {/* Info da inserire */}
            <Card />
        </div>
  );
}